import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RecommendationCard from "../../components/RecommendationCard/RecommendationCard";
import Pagination from "../../../common/components/Pagination/Pagination_2";
import MetricsCard from "../../components/MetricsCard/MetricsCard";
import Sidebar from '../../../common/components/Main Menu/MainMenu';
import Breadcrumb from "../../../common/components/NavigationBreadcrumb/Breadcrumb";
import NewTab from "../../../agent/components/NewTab/NewTab/NewTab";
import Navbar from "../../../common/components/HeaderOpsPage/Navbar"
import './AgentImprovement.css';
import { fetchRecommendationsStart } from "../../../redux/slices/agentHomeSlice";
import { Spinner } from "react-bootstrap";

function AgentImprovement({ dataAccessor, cardHeader }) {
  const dispatch = useDispatch();

  const recommendations = useSelector(
    (state) => state.agentHome.recommendations[dataAccessor] || []
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(1); // Keep as 1, removed setter
  const loading = useSelector((state) => state.operationHome.loading);
  const [currentRecommendation, setCurrentRecommendation] = useState(null);

  useEffect(() => {
    dispatch(fetchRecommendationsStart());
  }, []);

  const totalDataCount = recommendations?.length || 0;
  const totalPagesCount = totalDataCount > 0 ? Math.ceil(totalDataCount / pageSize) : 0;
  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;

  useEffect(() => {
    if (recommendations?.[currentPage - 1]) {
      setCurrentRecommendation(recommendations[currentPage - 1]);
    }
  }, [recommendations, currentPage]);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const breadcrumbItems = [
    { label: "Home", link: "/landing" },
    { label: "Ops Portal", link: "/operationHome", state: { from: "details" } },
    { label: `${cardHeader} Improvement Insight` },
  ];

  return (
    <div className="agent-main">
      <div className="agent-app d-flex">
        <div className="agent-header-container">
          <Navbar />
        </div>
        <div className="agent-main-container">
          {/* <Sidebar className="sidebar" /> */}
          <div className="agent-operations-home container-fluid">
            <div className="my-3">
              <Breadcrumb
                breadcrumbItems={breadcrumbItems}
                backLink="/operationHome"
                backLinkState={{ from: "details" }}
              />
            </div>
            <NewTab />
            <div className="my-3 agent-operations-search-panel"></div>
            <div className="row">
              <div className="col-12">
                <div className="row g-4 agent-improvement-top-container">
                  <div className="agent-improvement-container">
                    <RecommendationCard
                      recommendationCardTitle={cardHeader}
                      recommendation={currentRecommendation}
                      currentPage={currentPage}
                      totalPages={totalDataCount}
                    />

                    <div className="agent-improvement-footer">
                     <Pagination
                  totalPage={totalPagesCount}
                 currentPage={currentPage}
               paginateHandler={handlePageChange}
               totalData={totalDataCount}
                tableStartIndex={indexOfFirstItem + 1}
             tableEndIndex={Math.min(indexOfLastItem, totalDataCount)}
                  showRowsPerPage={false}   // ✅ hides dropdown
                       />
                    </div>
                  </div>

                  <div style={{ width: "30%" }}>
                    <MetricsCard
                      metrics={currentRecommendation}
                      dataAccessor={dataAccessor}
                      currentPage={currentPage}
                      recommendationCardTitle={cardHeader}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentImprovement;